/// <reference path='haori.d.ts' />

declare var bootstrap: any;

(function (global) {
  // サポート外ブラウザのメッセージ
  const MESSAGE_LEGACY_BROWSER =
    '申し訳ございませんがご利用のブラウザはサポートしておりません。\nEdge、Chrome等の最新のブラウザをご利用ください。';

  // ログイン失敗メッセージ
  const MESSAGE_LOGIN_FAILED = 'ログインに失敗しました';

  // 未ログインメッセージ
  const MESSAGE_LOGIN_TIMEOUT = 'ログインしていないかタイムアウトしました。\nもう一度ログインをお願いします。';

  // 閲覧禁止メッセージ
  const MESSAGE_FORBIDDEN = '現在アクセスが禁止されています';

  // 対象不明メッセージ
  const MESSAGE_NOT_FOUND = '対象が存在しません';

  // その他のエラーメッセージ
  const MESSAGE_UNKNOWN_ERROR = '予期しないエラーが発生しました';

  // ログインアラート表示フラグ
  let loginAlert = false;

  window.addEventListener('load', () => {
    // サポート外のブラウザチェック
    var ua = navigator.userAgent;
    if (ua.indexOf('MSIE ') > -1 || ua.indexOf('Trident/') > -1) {
      alert(MESSAGE_LEGACY_BROWSER);
      return;
    }

    // ロード時にbodyにクラスを追加する（画面レイアウトが一瞬崩れるのを防ぐため）
    document.body.classList.add('ready');
  });

  // Haoriのオプション設定
  Haori.options.alertProcess = (message) => {
    return new Promise((resolve) => {
      let modal = document.createElement('div');
      modal.setAttribute('data-bs-backdrop', 'static');
      modal.classList.add('modal', 'fade', 'modal-alert');
      modal.innerHTML =
        '<div class="modal-dialog"><div class="modal-content">' +
        '<div class="modal-body" style="white-space: pre-line"></div>' +
        '<div class="modal-footer"><button type="button" class="btn btn-primary" data-bs-dismiss="modal">OK</button></div>' +
        '</div></div>';
      (<HTMLElement>modal.querySelector('.modal-body')).textContent = message.replace(/\\n/g, '\n');
      document.body.appendChild(modal);
      let modalObject = new bootstrap.Modal(modal);
      modal.addEventListener('hide.bs.modal', () => {
        resolve();
      });
      modal.addEventListener('hidden.bs.modal', () => {
        modal.remove();
      });
      modalObject.show();
    });
  };
  Haori.options.messageProcess = async (message, level) => {
    let container = document.getElementById('haori-toast-container');
    if (container == null) {
      let area = document.createElement('div');
      area.classList.add('position-fixed', 'top-0', 'bottom-0', 'start-0', 'end-0', 'pe-none');
      area.style.zIndex = '1100';
      document.body.appendChild(area);

      container = document.createElement('div');
      container.setAttribute('id', 'haori-toast-container');
      container.classList.add('toast-container', 'position-absolute', 'p-4', 'bottom-0', 'end-0');
      area.appendChild(container);
    }
    let toast = document.createElement('div');
    toast.classList.add('toast', 'd-flex', 'align-items-center');
    switch (level) {
      case HaoriMessageLevel.SUCCESS:
        toast.classList.add('bg-success', 'text-white');
        break;
      case HaoriMessageLevel.INFO:
        toast.classList.add('bg-info', 'text-dark');
        break;
      case HaoriMessageLevel.WARNING:
        toast.classList.add('bg-warning', 'text-dark');
        break;
      case HaoriMessageLevel.DANGER:
        toast.classList.add('bg-danger', 'text-white');
        break;
    }
    toast.innerHTML =
      '<div class="toast-body" style="white-space: pre-line"></div>' +
      '<button type="button" class="btn-close btn-close-white ms-auto me-2" data-bs-dismiss="toast" aria-label="Close"></button>';
    container.appendChild(toast);

    (<HTMLElement>toast.querySelector('.toast-body')).textContent = message.replace(/\\n/g, '\n');

    new bootstrap.Toast(toast).show();
  };
  Haori.options.confirmProcess = (message) => {
    return new Promise((resolve) => {
      let modal = document.createElement('div');
      modal.setAttribute('data-bs-backdrop', 'static');
      modal.classList.add('modal', 'fade', 'modal-confirm');
      modal.innerHTML =
        '<div class="modal-dialog"><div class="modal-content">' +
        '<div class="modal-body" style="white-space: pre-line"></div>' +
        '<div class="modal-footer"><button type="button" class="btn btn-secondary" data-value="false">キャンセル</button><button type="button" class="btn btn-primary" data-value="true">OK</button></div>' +
        '</div></div>';
      (<HTMLElement>modal.querySelector('.modal-body')).textContent = message.replace(/\\n/g, '\n');
      document.body.appendChild(modal);
      let modalObject = new bootstrap.Modal(modal);
      let value: boolean;
      modal.querySelectorAll('[data-value]').forEach((element) => {
        element.addEventListener('click', () => {
          value = element.getAttribute('data-value') == 'true';
          modalObject.hide();
        });
      });
      modal.addEventListener('hide.bs.modal', () => {
        resolve(value);
      });
      modal.addEventListener('hidden.bs.modal', () => {
        modal.remove();
      });
      modalObject.show();
    });
  };
  Haori.options.requestConverter = (url, request) => {
    if (location.host != '127.0.0.1:5500') {
      return url;
    }
    // 画面開発モード（GETメソッドに変換する）
    if (request.method != null && request.method.toUpperCase() != 'GET') {
      let params = new URLSearchParams();
      params.set('METHOD', request.method);
      request.method = 'GET';
      if (request.body) {
        let object = JSON.parse(request.body.toString());
        for (let key in object) {
          if (typeof object[key] == 'object') {
            params.set(key, JSON.stringify(object[key]));
          } else {
            params.set(key, object[key]);
          }
        }
        request.body = undefined;
      }
      if (url.indexOf('?') < 0) {
        url += '?';
      } else {
        url += '&';
      }
      url += params.toString();
    }
    return url;
  };
  Haori.options.responseConverter = async (url, request, response) => {
    if (location.host == '127.0.0.1:5500') {
      // 画面開発モード（ステータスを置き換える）
      let point = url.indexOf('?');
      if (point >= 0) {
        let params = new URLSearchParams(url.substring(point));
        let method = params.get('METHOD');
        if (method) {
          request.method = method;
        }
      }
      let status = response.status;
      let statusText = response.statusText;
      let contentType = response.headers.get('Content-Type');
      if (contentType && contentType.indexOf('application/json') == 0) {
        let cloneResponse = response.clone();
        await cloneResponse
          .json()
          .then((object) => {
            if (Array.isArray(object)) {
              object = object[0];
            }
            if (object.STATUS_TEXT) {
              statusText = object.STATUS_TEXT;
            }
            if (object.STATUS) {
              status = object.STATUS;
              if (status == 400 && object.RESPONSE) {
                object = object.RESPONSE;
              }
            }
          })
          .catch((error) => {
            console.error(error);
          });
      } else if (contentType && (contentType.indexOf('text/csv') == 0 || contentType.indexOf('application/csv') == 0)) {
        let cloneResponse = response.clone();
        await cloneResponse
          .text()
          .then((text) => {
            let line = text.substring(text.indexOf('\n'));
            let params = line.split(',');
            if ((params.length == 1 || params.length == 2) && params[0].match(/[0-9]{3}/)) {
              status = parseInt(params[0]);
              if (params.length == 2) {
                statusText = params[1];
              }
            }
          })
          .catch((error) => {
            console.error(error);
          });
      }
      response = new Response(response.body, {
        headers: response.headers,
        status: status,
        statusText: statusText,
      });
    }
    if (response.status == 401 || response.status == 403) {
      let loginUrl = document.body.getAttribute('data-login');
      if (loginUrl != null && !loginAlert) {
        loginAlert = true;
        sessionStorage.clear();
        Haori.alert(MESSAGE_LOGIN_TIMEOUT).then(() => {
          location.href =
            loginUrl! +
            (loginUrl.indexOf('?') > 0 ? '&' : '?') +
            'href=' +
            encodeURIComponent(location.pathname.replace(/:/g, '') + (location.search ? '?' + location.search : ''));
          loginAlert = false;
        });
      }
    }
    return response;
  };
  Haori.options.errorMessageConverter = (url, request, response, reason) => {
    if (
      response.status != 401 &&
      (response == null || (reason != null && reason != '' && JSON.stringify(reason) != '{}'))
    ) {
      return reason;
    }
    switch (response.status) {
      case 401:
        if (request.method == null || request.method != 'POST') {
          return null;
        }
        return MESSAGE_LOGIN_FAILED;
      case 403:
        return MESSAGE_FORBIDDEN;
      case 404:
        return MESSAGE_NOT_FOUND;
      default:
        return MESSAGE_UNKNOWN_ERROR;
    }
  };
  Haori.options.findDialog = (target, selector) => {
    if (selector == null || selector == '') {
      return target.closest('.modal');
    } else {
      return document.querySelector(selector);
    }
  };
  Haori.options.openDialog = (element) => {
    new bootstrap.Modal(element).show();
  };
  Haori.options.closeDialog = (element) => {
    let modal = bootstrap.Modal.getInstance(element);
    if (modal) {
      modal.hide();
    }
  };
  Haori.options.useStorageCache = () => {
    if (location.host == '127.0.0.1:5500') {
      return false;
    }
    return true;
  };

  // フォームメッセージを適宜表示する
  document.addEventListener('add-message', (event) => {
    let target = <Element>event.target;
    if (target.tagName == 'FORM') {
      let form = target;
      let modalBody = target.querySelector('.modal-body');
      if (modalBody != null) {
        target = modalBody;
      }
      let alert = document.createElement('div');
      if (form.classList.contains('invalid')) {
        alert.classList.add('alert', 'alert-danger', 'haori-embedded-alert');
      } else {
        alert.classList.add('alert', 'alert-success', 'haori-embedded-alert');
      }
      alert.textContent = form.getAttribute('data-message');
      target.insertBefore(alert, target.firstChild);
    } else {
      let feedback = document.createElement('div');
      feedback.classList.add('invalid-feedback', 'haori-embedded-alert');
      feedback.textContent = target.getAttribute('data-message');
      target.appendChild(feedback);
      target.querySelectorAll('input.invalid, select.invalid, textarea.invalid').forEach((element) => {
        element.classList.add('is-invalid');
      });
    }
  });

  // フォームリセット時にアラートを削除する
  document.addEventListener('reset', (event) => {
    let target = <Element>event.target;
    if (target.tagName == 'FORM') {
      let form = target;
      form.querySelectorAll('.haori-embedded-alert').forEach((element) => {
        element.remove();
      });
    }
  });

  // クリアメッセージ時に追加したメッセージとアラートを削除する
  document.addEventListener('clear-messages', (event) => {
    let target = <Element>event.target;
    target.querySelectorAll('.is-invalid').forEach((element) => {
      element.classList.remove('is-invalid');
    });
    target.querySelectorAll('.haori-embedded-alert').forEach((element) => {
      element.remove();
    });
  });

  // action属性がないformのsubmitイベントを抑制する（Enterキー対応）
  document.addEventListener('submit', (event) => {
    let target = <Element>event.target;
    if (target.tagName == 'FORM' && !target.hasAttribute('action')) {
      event.preventDefault();
    }
  });
})(this);
